import React from "react";

const ContactInfo = () => (
  <div className="col-xl-4 mt-60 mt-xl-0 animate" data-animation="scaleAppear">
    <div className="ls ms p-30">
      <h4 className="special-heading underline">Contact Info</h4>

      <div className="divider-30"></div>

      <div className="media mb-20">
        <div className="media-body">
          <h5>Phone:</h5>
          <p>+14694764730</p>
        </div>
      </div>

      <div className="media mb-20">
        <div className="media-body">
          <h5>Email:</h5>
          <p>
            <a href="mailto:info@justmovedtoyankee.com">
              info@justmovedtoyankee.com
            </a>
          </p>
        </div>
      </div>
    </div>
  </div>
);

export default ContactInfo;
